export const BREAKPOINT = {
	md: 768,
	lg: 1024,
	lg1: 1240,
	lg2: 1280,
	xl: 1440,
} as const;

export const COPY_ADDITIONAL_TEXT = {
	ru: '\n\nИсточник и подробности: ',
	en: '\n\nИсточник и подробности: ',
} as const;

export const FALLBACK_TITLE_PAGE = {
	avtory: 'Авторы | энциклопедия',
	ot_redkollegii: 'От редколегии | энциклопедия',
	ot_izdatelya: 'От издателя | энциклопедия',
	sokrashcheniya: 'Сокращения | энциклопедия',
	article: 'Статьи | энциклопедия',
	newsDetail: 'Новость',
} as const;

export const MAIN_TITLE = 'Серия энциклопедических словарей «Ислам в Российской Федерации»';

export const PAGINATION_BUTTONS = 6;
